( function () {
	'use strict';

	/* @ngInject */
	function scheduleservice ( apiService, logger, moment, filterFilter, Session, $location, startobsservice, $q ) {
		var credentials = Session.getCredentials();

		function getStartTime ( schedule ) {
			return new Date( moment( schedule.scheduledDate ).format( 'MMMM D, YYYY HH:mm:ss' ) );
		}

		function getEndTime ( schedule ) {
			return new Date( moment( schedule.scheduledDate ).add( 1, 'h' ).format( 'MMMM D, YYYY HH:mm:ss' ) );
		}

		function getScheduledDate ( date, time ) {
			var formattedDate = moment( date ).format( 'MMMM D, YYYY' ) + ' ' + moment( time ).format( 'HH:mm:ss' );

			return new Date( formattedDate );
		}

		function getSearchableDate ( schedule ) {
			return moment( schedule.scheduledDate ).format( 'MMMM D, YYYY HH:mm' );
		}

		function getStandardizeDate ( schedule ) {
			var dateFormat        = 'MMM. D, YYYY H:mm';
			var spelledOutMonths  = [ 'June', 'July', 'May' ];
			var isSpelledoutMonth = filterFilter( spelledOutMonths, function ( month ) {
				return moment( schedule.scheduledDate ).format( 'MMMM' ) === month;
			} );

			if ( isSpelledoutMonth.length ) {
				dateFormat = 'MMMM D, YYYY hh:mm A';
			}

			return moment( schedule.scheduledDate ).format( dateFormat );
		}

		function getInviteeIds ( invitees ) {
			return invitees.map( function ( invitee ) {
				return invitee.id || invitee;
			} );
		}

		function isPastEvent ( schedule ) {
			return moment( schedule.eventDate ).format( 'x' ) < moment( moment( new Date() ).format( 'L' ), 'MM-DD-YYYY' ).format( 'x' );
		}

		function redirectToObs ( schedule ) {
			var performRoute = '';

			if ( schedule.status !== 'Completed' ) {
				performRoute = '/' + 'edit';
			}
			$location.path( '/observations/' + schedule.id + performRoute );
		}

		function confirmStartObs ( schedule ) {
			if ( schedule.status === 'In Progress' || schedule.status === 'Completed' ) {
				redirectToObs( schedule );
			} else {
				startobsservice.openModal( schedule );
			}
		}

		function redirectToScheds () {
			$location.path( '/schedules' );
		}

		function getSchedStatus ( schedule ) {
			return apiService.obsStatus
				.get( {
					'userId'        : credentials.userId.toString(),
					'observations'  : 'observations',
					'observationId' : schedule.id
				} )
				.$promise.then( function ( res ) {
					var type   = 'success';
					var status = 'Submitted';

					if ( res.partialSubmission ) {
						type   = 'warning';
						status = 'In Progress';
					}

					schedule.type      = type;
					schedule.editable  = false;
					schedule.deletable = res.partialSubmission;
					schedule.status    = status;

					return res;
				}, function ( err ) {
					logger.error( err );
					schedule.type      = 'info';
					schedule.editable  = true;
					schedule.deletable = true;
					schedule.status    = 'Scheduled';
					return err;
				} );
		}

		function scheduleMapper ( schedule ) {
			schedule.title                = schedule.name;
			schedule.startsAt             = schedule.startDate;
			schedule.endsAt               = schedule.endDate;
			schedule.incrementsBadgeTotal = true;
			schedule.editable             = parseInt( schedule.creatorId ) === parseInt( credentials.userId );
			schedule.deletable            = schedule.editable;
			schedule.status               = 'Meeting';

			if ( !schedule.meta.invitees ) {
				schedule.status       = 'Scheduled';
				schedule.calendarType = 'info';
			}
		}

		function inInvitees ( invitees, id ) {
			return invitees.some( function ( invitee ) {
				return invitee === id;
			} );
		}

		function packPayload ( schedule ) {
			var payload = {
				'name'      : schedule.name,
				'startDate' : getScheduledDate( schedule.eventDate, schedule.startTime ),
				'endDate'   : getScheduledDate( schedule.endDate, schedule.endTime ),
				'type'      : schedule.type.toLowerCase(),
				'isHidden'  : schedule.isEventHidden,
				'meta'      : {
					'location' : schedule.room
				}
			};

			if ( schedule.templateId ) {
				payload.meta.templateId = schedule.templateId.toString();
				payload.meta.observee   = [ schedule.observeeId ];
				payload.meta.observer   = [ credentials.userId ];
			} else {
				payload.description   = schedule.description;
				payload.meta.invitees = getInviteeIds( schedule.invitees );

				if ( !inInvitees( payload.meta.invitees, credentials.userId ) ) {
					payload.meta.invitees.push( credentials.userId );
				}
			}

			return payload;
		}

		function groupMapper ( group ) {
			delete group.score;
		}

		function packObsPayload ( schedule ) {
			// remove score on template
			delete schedule.template.score;

			schedule.template.groups.map( groupMapper );

			return {
				'id'       : schedule.meta.observationId,
				'name'     : schedule.name,
				'observee' : {
					'id' : schedule.meta.observee[ 0 ]
				},

				'location' : {
					'observeeClientId' : schedule.observeeClientId
				},

				'template'          : schedule.template,
				'partialSubmission' : true,
				'startDate'         : schedule.startDate,
				'endDate'           : schedule.endDate,
				'scheduledDate'     : schedule.startDate,
				'tags'              : [ ],
				'observer'          : {
					'id' : credentials.userId
				}
			};
		}

		function packEditPayload ( schedule ) {
			var payload = {
				'id'        : schedule.id,
				'name'      : schedule.name,
				'startDate' : getScheduledDate( schedule.eventDate, schedule.startTime ),
				'endDate'   : getScheduledDate( schedule.endDate, schedule.endTime ),
				'isHidden'  : schedule.isEventHidden,
				'meta'      : {
					'location' : schedule.meta.location
				}
			};

			if ( schedule.status === 'Meeting' ) {
				payload.type          = 'meeting';
				payload.meta.invitees = schedule.meta.invitees;
				payload.meta.location = schedule.meta.location;
				payload.description   = schedule.description || null;

				if ( !inInvitees( payload.meta.invitees, credentials.userId ) ) {
					payload.meta.invitees.push( credentials.userId );
				}
			} else {
				payload.type               = 'observation';
				payload.meta.templateId    = schedule.templateId;
				payload.meta.observee      = [ schedule.observeeId || schedule.meta.observee[ 0 ] ];
				payload.meta.observer      = [ credentials.userId ];

				if ( schedule.meta.observationId ) {
					payload.meta.observationId = schedule.meta.observationId;
				}
			}

			return payload;
		}

		function getUser ( id, foundUsers ) {
			return foundUsers.filter( function ( val ) {
				return val.id === id[ 0 ];
			} )[ 0 ].name;
		}

		function lookForObservee ( sched ) {
			return sched.type === 'observation';
		}

		function lookForInvitee ( sched ) {
			return sched.type === 'meeting';
		}
		function turnIntoPromise ( sched, target ) {
			function formObserveeName ( obs ) {
				return {
					'id'   : obs.PersonnelId,
					'name' : obs.FirstName + ' ' + obs.LastName
				};
			}

			return apiService.observation.get( { 'userId' : sched.meta[ target ][ 0 ] } ).$promise.then( formObserveeName );
		}

		function observeePromiseMapper ( sched ) {
			return turnIntoPromise( sched, 'observee' );
		}

		function inviteePromiseMapper ( sched ) {
			return turnIntoPromise( sched, 'invitees' );
		}

		function getSchedules () {
			return apiService.userEvents
				.query( {
					'userId' : credentials.userId.toString()
				}, {
					'startDate' : new Date(),
					'endDate'   : new Date()
				} )
				.$promise.then( function ( res ) {
					res = res.filter( function ( data ) {
						return !data.deletedAt;
					} );

					res.map( scheduleMapper );

					var promises = res.filter( lookForObservee )
						.map( observeePromiseMapper )
						.concat( res.filter( lookForInvitee )
						.map( inviteePromiseMapper ) );

					$q.all( promises )
					.then( function ( foundUsers ) {
						res.filter( function ( val ) {
							return !val.observee && !val.invitee && val.meta;
						} ).map( function ( val ) {
							val.observee = {
								'name' : getUser( val.meta.invitees || val.meta.observee, foundUsers )
							};
							val.invitee = {
								'name' : getUser( val.meta.invitees || val.meta.observee, foundUsers )
							};
							return val;
						} );

						return res;
					} )
					.then( function () {
						res.filter( function ( val ) {
							return val.type.toString() === 'observation' && !val.template;
						} ).forEach( function ( value ) {
							return apiService.templates
							.query( {
								'userId' : value.meta.observer[ 0 ]
							} ).$promise.then( function ( templateResult ) {
								templateResult.filter( function ( val ) {
									return val.id.toString() === value.meta.templateId;
								} ).map( function ( val ) {
									value.template = {
										'name' : val.name
									};
								} );
							} ).then( function () {
								value.isDoneLoading = true;
							} );
						} );
					} );

					return res;
				} )
				.then( function ( data ) {
					return data;
				} )
				.catch( function ( err ) {
					logger.error( err );
					return err;
				} );
		}

		function saveSchedule ( schedule ) {
			return apiService.events
				.save( packPayload( schedule ) )
				.$promise.then( function ( res ) {
					logger.info( 'Schedule successfully saved.' );

					return res;
				}, function ( err ) {
					logger.error( err );
					return err;
				} );
		}

		function saveObservation ( schedule ) {
			return apiService.observation
				.save( {
					'userId'      : credentials.userId.toString(),
					'observation' : 'observation'
				}, packObsPayload( schedule ) )
				.$promise.then( function ( res ) {
					logger.info( 'Observation successfully saved.' );
					return res;
				} );
		}

		function updateSchedule ( schedule ) {
			return apiService.events
				.update( {
					'eventId' : schedule.id.toString()
				}, packEditPayload( schedule ) )
				.$promise.then( function ( res ) {
					return res;
				}, function ( err ) {
					logger.error( err );
					return err;
				} );
		}

		function deleteSchedule ( schedule ) {
			return apiService.events
				.remove( {
					'eventId' : schedule.id
				} )
				.$promise.then( function ( res ) {
					return res;
				}, function ( err ) {
					logger.error( err );
					return err;
				} );
		}

		function getObservation ( schedule ) {
			return apiService.observation.get( {
				'userId'        : schedule.observer.id,
				'observationId' : schedule.id,
				'observation'   : 'observations'
			} ).$promise.then( function ( res ) {
				return res;
			} );
		}

		function updateObservation ( schedule ) {
			var endDate = moment( schedule.endDate ).format( 'MM/DD/YYYY' ) + ' ' + moment( schedule.endTime ).format( 'h:mm a' );

			delete schedule.template.isFav;
			var payload = {
				'id'                : schedule.id,
				'name'              : schedule.name,
				'observer'          : { 'id' : schedule.observer.id },
				'observee'          : { 'id' : schedule.observee.id },
				'location'          : schedule.location,
				'scheduledDate'     : schedule.scheduledDate,
				'startDate'         : schedule.eventDate,
				'endDate'           : moment( endDate ).utc(),
				'submitDate'        : schedule.submitDate,
				'partialSubmission' : true,
				'type'              : [ null ],
				'tags'              : [ null ],
				'template'          : schedule.template
			};

			return apiService.observation.update( {
				'userId'      : schedule.observer.id,
				'observation' : 'observation'
			}, payload ).$promise.then( function ( res ) {
				return res;
			} );
		}

		return {
			'isPastEvent'        : isPastEvent,
			'getStartTime'       : getStartTime,
			'getEndTime'         : getEndTime,
			'getScheduledDate'   : getScheduledDate,
			'getSearchableDate'  : getSearchableDate,
			'getStandardizeDate' : getStandardizeDate,
			'confirmStartObs'    : confirmStartObs,
			'redirectToObs'      : redirectToObs,
			'redirectToScheds'   : redirectToScheds,
			'getSchedStatus'     : getSchedStatus,
			'scheduleMapper'     : scheduleMapper,
			'getSchedules'       : getSchedules,
			'saveSchedule'       : saveSchedule,
			'saveObservation'    : saveObservation,
			'updateSchedule'     : updateSchedule,
			'deleteSchedule'     : deleteSchedule,
			'getObservation'     : getObservation,
			'updateObservation'  : updateObservation
		};
	}

	angular
		.module( 'app.schedules' )
		.factory( 'scheduleservice', scheduleservice );
} )( );
